///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import TruckloadIcon from "../../components/icons/TruckloadIcon";
import LessThanTruckloadIcon from "../../components/icons/LessThanTruckloadIcon";
import IntermodalIcon from "../../components/icons/IntermodalIcon";
import { bidScacType, bidTypes, division, mode } from "../../helpers/types";
import messages from "../../helpers/messages";

function Modes({
  bid: { modes, bidType, bidScac },
  handleModeSelection,
  userDivision,
  disableIMDLBid
}) {
  const isModeSelected = type => {
    return modes.some(x => x.mode === type);
  };

  const isModeAvailable = modeType => {
    if (disableIMDLBid && modeType === mode.imdl) {
      return false;
    }

    if (!bidScac) {
      return true;
    }

    if (bidScac.value === bidScacType[1].value) {
      return modeType === mode.tl;
    }

    if (bidScac.value === bidScacType[0].value) {
      return modeType === mode.ltl || modeType === mode.imdl;
    }

    return true;
  };

  const renderMode = (type, icon, text, className) => {
    return (
      <button
        data-testid={text}
        className={`bg-white ${className ? className : ""} ${
          isModeSelected(type) ? "selected" : ""
        }`}
        onClick={() => handleModeSelection(type)}
      >
        {icon}
        <span className="block zeta pt-8">{text}</span>
      </button>
    );
  };

  const coyoteFleetBidType = bidTypes.find(
    x => x.label === messages.coyoteFleet.defaultMessage
  ).value;

  return (
    <>
      <span>{messages.selectPertainingModes.defaultMessage}</span>
      <div className="mode-selected pt-12 pb-24">
        {isModeAvailable(mode.tl) &&
          renderMode(
            mode.tl,
            <TruckloadIcon width="55" height="22" />,
            messages.truckload.defaultMessage,
            "mr-24"
          )}
        {userDivision === division.coy &&
          bidType?.value !== coyoteFleetBidType &&
          isModeAvailable(mode.ltl) &&
          renderMode(
            mode.ltl,
            <LessThanTruckloadIcon width="55" height="22" />,
            messages.lessThanTruckload.defaultMessage,
            "mr-24"
          )}
        {userDivision === division.coy &&
          bidType?.value !== coyoteFleetBidType &&
          isModeAvailable(mode.imdl) &&
          renderMode(
            mode.imdl,
            <IntermodalIcon width="55" height="22" />,
            messages.intermodal.defaultMessage
          )}
      </div>
    </>
  );
}

export default Modes;
